export default __webpack_public_path__ + "static/media/apple-Imac.4543a4f8.jpg";